import axios from 'axios'
import { FEATURES, URLS } from '../factories'
import { ApplicationModule, AuthModule } from '../store'
import ApplicationFormDto from '../types/dto/applicationFormDto'
import EmploymentDto from '../types/dto/employmentDto'
import LookupValueDto from '../types/dto/lookupValueDto'
import UtmDto from '../types/dto/utmDto'
import AddressDto from '../types/dto/addressDto'
import { FeatureSwitchService } from '.'

export default {
  async prePopAppForm () {
    const tokenString = 'Bearer ' + AuthModule.token!.authenticationToken
    const headersObj = { Authorization: tokenString }

    const delegateFn = async () => {
      const applicationApiFullUrl = AuthModule.isProduction ? URLS.production.applicationApiFullUrl : URLS.replica.applicationApiFullUrl

      const params: any = { appId: ApplicationModule.applicationID, validation: false }
      if (ApplicationModule.quoteId) {
        params.quoteId = ApplicationModule.quoteId
      }

      const response = await axios({
        method: 'GET',
        url: applicationApiFullUrl + '/api/LoanApplication',
        headers: headersObj,
        params: params
      })

      if (response === null) {
        return
      }

			window.console.log('Response Data', response.data);

      const existingApp = response.data as ApplicationFormDto
      // cannot find referral
      if (!existingApp.clientId || existingApp.clientId === '' || existingApp.clientId === '00000000-0000-0000-0000-000000000000') {
        ApplicationModule.updateIsPrePopped(false)
        return
      }

      ApplicationModule.updateIsPrePopped(true)

      if (existingApp.dateOfBirth) {
        ApplicationModule.updateDobDay(new Date(existingApp.dateOfBirth).getDate())
        ApplicationModule.updateDobMonth(new Date(existingApp.dateOfBirth).getMonth() + 1)
        ApplicationModule.updateDobYear(new Date(existingApp.dateOfBirth).getFullYear())
      }

      // Checks from
      if (!existingApp.drivingLicence) {
        existingApp.drivingLicence = {
          id: undefined // TODO - what to set if none from api
        } as LookupValueDto
      }

      if (!existingApp.title) {
        existingApp.title = {
          id: undefined // TODO - what to set if none from api
        } as LookupValueDto
      }

      if (!existingApp.maritalStatus) {
        existingApp.maritalStatus = {
          id: undefined // TODO - what to set if none from api
        } as LookupValueDto
      }

      if (!existingApp.employments || existingApp.employments.length === 0 || existingApp.employments[0] === null) {
        existingApp.employments = [
					{
					  employmentStatusLookup: {
					    id: null
					  } as LookupValueDto,
					  yearsAtEmployer: null,
					  monthsAtEmployer: null,
					  employerName: '',
					  employerTown: '',
					  occupation: '',
					  employmentLevel: 0
					} as EmploymentDto
        ] as EmploymentDto[]
      }

			window.console.log('Address', existingApp.addresses);

      if (!existingApp.addresses || existingApp.addresses.length === 0 || existingApp.addresses[0] === null) {
        existingApp.addresses = [
					{
					  residentialStatusLookup: {
					    id: undefined
					  } as LookupValueDto,
					  yearsAtAddress: 0,
					  monthsAtAddress: 0,
					  postcode: '',
					  buildingName: '',
					  buildingNumber: '',
					  county: '',
					  flatNumber: '',
					  locality: '',
					  street: '',
					  subBuilding: '',
					  town: '',
					  addressId: -1,
					  addressLevel: 0
					} as AddressDto
        ] as AddressDto[]
      }

      // remove null entries sent by affiliate - EXPERIAN >:(
      existingApp.addresses = existingApp.addresses.filter(a => a)
      existingApp.employments = existingApp.employments.filter(e => e)

      if (!existingApp.utmParameters) {
        existingApp.utmParameters = {} as UtmDto
      }

      ApplicationModule.updateAgreedToTerms(existingApp.agreedToTermsAndConditions)
      ApplicationModule.updateForm(existingApp)
      ApplicationModule.updateFormCopy(existingApp)
    }

		await delegateFn();
  }
}
